<template>
  <div
    class="modal_overlay"
    @click="$store.commit('hideModal')"
    :class="{ active: $store.state.show_modal }"
  >
    <div
      class="big_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'settings_modal' }"
      @click.stop
    >
      <modalHeader>Room settings</modalHeader>

      <div class="inner">
        <RoomSettings v-if="meetingState" />

        <Devices v-if="meetingState" />

        <RoomBrandingSettings v-if="user && meetingState" />
        <!-- <UpdateRoomTheme /> -->
        <!-- <div class="error_notificatin df s_center" v-if="meetingState === 'joined-meeting'">
                  <img src="@/assets/img/error_icon.svg" alt="">

                  Error notification
              </div> -->
      </div>
    </div>

    <div
      v-if="meetingState"
      class="big_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'people_modal' }"
      @click.stop
    >
      <modalHeader>People</modalHeader>

      <div class="inner">
        <div class="room_counter">
          <img src="@/assets/img/peoples_icon.svg" alt="" />
          {{ meetingParticipants.length }}
          of 100
        </div>

        <Participants />
      </div>

      <a
        href="/auth/login"
        target="_blank"
        class="settings_apply color_btn hover_op"
        @click="$store.commit('hideModal')"
        v-if="authenticated == false"
      >
        Upgrade
      </a>
    </div>

    <div
      class="big_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'chat_modal' }"
      @click.stop
    >
      <modalHeader>Chat</modalHeader>

      <div class="inner" id="chatInner">
        <message-list :messages="messages" />
      </div>

      <message-input />
    </div>

    <div
      class="big_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'recordings_modal' }"
      @click.stop
    >
      <modalHeader>Recordings</modalHeader>

      <recordingsModal></recordingsModal>
    </div>
    
    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'upgrade_modal' }"
      @click.stop
    >
      <modalHeader>Upgrade</modalHeader>

      <p class="upgrade_big">Want to upgrade?</p>

      <p>You need to upgrade the plan in order to record the call.</p>

      <router-link
        to="/pricing"
        class="color_btn hover_op"
        @click="$store.commit('hideModal')"
        >Upgrade
      </router-link>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'premision_modal' }"
      @click.stop
    >
      <modalHeader>Premmisions</modalHeader>

      <p class="upgrade_big">
        Your browser needs camera and microphone access.
      </p>

      <p class="text-a">
        1. Click the camera icon in your browser's
        <img
          class="blocked-camera-icon"
          width="24"
          height="24"
          src="../assets/chrome-light.png"
          alt=""
          style="vertical-align: middle"
        />
        address bar <br />
        <br />
        2. Select “Always allow”, then click Done
      </p>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'join_modal' }"
      @click.stop
    >
      <modalHeader>Join GetSynced</modalHeader>

      <p class="upgrade_big">New to GetSynced?</p>

      <p>
        Do you also want to create your own room? You can register quickly while
        you wait.
      </p>

      <button class="colored_btn join_btn">Sign up w/ Google</button>

      <button class="colored_btn join_btn">Sign up w/ Facebook</button>

      <p class="or">Or</p>

      <router-link
        to="/auth/login"
        class="color_btn hover_op"
        @click="$store.commit('hideModal')"
        >Sign up w/ Email
      </router-link>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'delete_video' }"
      @click.stop
    >
      <modalHeader>Remove</modalHeader>

      <recordingRemoveConfirmModal></recordingRemoveConfirmModal>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'room_changed_modal' }"
      @click.stop
    >
      <modalHeader :hideClose="true">Room capacity</modalHeader>

      <p class="upgrade_big">Room capacity changed.</p>

      <p>The meeting was ended. Click okay to refresh</p>

      <button class="color_btn hover_op" @click="reload">Ok</button>
    </div>

    <div
      class="centered_modal modal"
      :class="{
        active: $store.state.shown_modal_name == 'changing_room_capacity',
      }"
      @click.stop
    >
      <modalHeader :hideClose="true">Room capacity</modalHeader>

      <p class="upgrade_big">Changing room capacity</p>

      <p>Please wait</p>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'ending_meeting' }"
      @click.stop
    >
      <modalHeader :hideClose="true">Meeting</modalHeader>

      <p class="upgrade_big">Ending meeting</p>

      <p>Please wait</p>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'invite_send' }"
      @click.stop
    >
      <modalHeader>Invite send</modalHeader>

      <p class="upgrade_big">Invite successful send to user email</p>

      <button class="color_btn hover_op" @click="$store.commit('hideModal')">
        Ok
      </button>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'verify_send' }"
      @click.stop
    >
      <modalHeader>Verification</modalHeader>

      <p class="upgrade_big">Verification email sent!</p>

      <button class="color_btn hover_op" @click="$store.commit('hideModal')">
        Ok
      </button>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'password_changed' }"
      @click.stop
    >
      <modalHeader>Password change</modalHeader>

      <p class="upgrade_big">Password changed!</p>

      <button class="color_btn hover_op" @click="$store.commit('hideModal')">
        Ok
      </button>
    </div>

    <div
      v-if="$store.state.shown_modal_name == 'video_modal'"
      class="video_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'video_modal' }"
      @click.stop
    >
      <recordingVideoModal @click.stop></recordingVideoModal>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'unlock_features' }"
      @click.stop
    >
      <modalHeader>Upgrade</modalHeader>

      <p class="upgrade_big">Unlock everything!</p>

      <p>Upgrading your plan allows you to unlock premium features.</p>

      <a href="/user_plan" class="color_btn hover_op">See plans & prices</a>

      <button
        class="hover_op transparent_btn"
        @click="$store.commit('hideModal')"
      >
        Later
      </button>
    </div>

    <div
      class="centered_modal modal"
      :class="{ active: $store.state.shown_modal_name == 'end_meeting' }"
      @click.stop
    >
      <modalHeader>End meeting</modalHeader>

      <p class="upgrade_big">End the meeting?</p>

      <p>You'll end meeting for everyone</p>

      <button class="hover_op color_btn" @click="endMeeting">
        Yes, end meeting
      </button>

      <button
        class="hover_op transparent_btn"
        @click="$store.commit('hideModal')"
      >
        No, keep it
      </button>
    </div>
  </div>
</template>

<script>
import dropDown from "@/components/dropDown.vue";
import Devices from "@/components/Devices";
import RoomBrandingSettings from "@/components/RoomBrandingSettings";
import RoomSettings from "@/components/RoomSettings";
import Chat from "@/components/chat/Chat";
import Participants from "@/components/Participants";
import MessageInput from "@/components/chat/MessageInput";
import modalHeader from "@/components/modalHeader.vue";
import userJoininDrop from "@/components/userJoininDrop.vue";
import recordingsModal from "@/components/recordings/recordingsModal.vue";
import recordingRemoveConfirmModal from "@/components/recordings/recordingRemoveConfirmModal.vue";
import recordingVideoModal from "@/components/recordings/recordingVideoModal.vue";
import UpdateRoomTheme from "./meeting/UpdateRoomTheme.vue";
import ChatInput from "./meeting/ChatInput.vue";
import MessageList from "./meeting/MessageList.vue";

export default {
  data() {
    return {
      inner_modal_name: this.modal_name,
      show: true,
    };
  },

  components: {
    dropDown,
    Devices,
    RoomSettings,
    RoomBrandingSettings,
    Chat,
    Participants,
    MessageInput,
    MessageList,
    modalHeader,
    recordingsModal,
    recordingRemoveConfirmModal,
    recordingVideoModal,
    UpdateRoomTheme,
    userJoininDrop,
    ChatInput,
    MessageList,
  },

  computed: {
    meetingState() {
      return this.$store.state.meeting.meeting;
    },
    meetingRoomName() {
      return this.meetingState?.dailyRoomName;
    },
    meetingParticipants() {
      return this.$store.state.meeting.participants;
    },
    user() {
      return this.$store.state.user;
    },

    isOwner() {
      return this.$store.getters.localParticipant.owner;
    },

    roomId() {
      return this.roomData?._id;
    },

    authenticated() {
      return this.$store.state.userAuthenticated;
    },
    messages() {
      let mess = this.$store.state.meeting.messages;
      const groupByDate = mess.reduce((group, message) => {
        const { createdAt } = message;
        group[createdAt.split("T")[0]] = group[createdAt.split("T")[0]] ?? [];
        group[createdAt.split("T")[0]].push(message);
        return group;
      }, {});

      return groupByDate;
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
    async endMeeting() {
      try {
        await this.$store.dispatch("endMeeting", true);
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }

      this.$store.commit("hideModal");
    },

    scrollChatModal() {
      var scrollChat = this.$el.querySelector("#chatInner");
      scrollChat.scrollTop = scrollChat.scrollHeight;
    },
  },

  updated() {
    this.scrollChatModal();
  },
};
</script>

<style lang="scss">
.modal_user {
  display: flex;
  align-items: center;

  & + .modal_user {
    margin-top: 16px;
  }

  .avatar {
    font-weight: 400;
    line-height: 24px;
    margin-right: 16px;
  }

  .name {
    flex: 1 1 auto;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: normal;
    line-height: 24px;
    text-align: left;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .call_more {
    height: 40px;
    flex: none;
    display: flex;
    align-items: center;
  }
}

.modal_overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.32);
  opacity: 0;
  pointer-events: none;
  transition: opacity 360ms;
  max-width: 100vw;
  max-height: 100vh;
  overflow: hidden;
  display: none;

  .logo_line {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: normal;
    line-height: 24px;
    text-align: left;
    margin-top: 32px;
  }

  .remove_btn {
    display: flex;
    align-items: center;

    img {
      margin-left: 16px;
    }
  }

  .room_counter {
    margin-bottom: 32px;
    text-align: center;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: normal;
    line-height: 24px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 22px;
      margin-right: 16px;
    }
  }

  .checkbox_wrap {
    margin-top: 32px;

    input {
      display: none;
    }

    label {
      cursor: pointer;
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 700;
      font-style: normal;
      letter-spacing: normal;
      line-height: 24px;
      text-align: left;
      display: flex;
      align-items: center;

      span {
        cursor: pointer;
        margin-right: 16px;
        width: 20px;
        height: 20px;
        border: 1px solid #000;
        border-radius: 4px;
      }
    }

    input:checked + label {
      span {
        background: url("../assets/img/checkbox_icon.svg") no-repeat center /
          30px;
      }
    }
  }

  &.active {
    display: block;
    opacity: 1;
    pointer-events: all;
    transition: opacity 360ms;
  }

  .headin {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 27px;

    @media all and (max-width: 767px) {
      margin-bottom: 16px;
    }

    & + .subtitle {
      margin-top: 0;
    }

    p,
    button {
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 0;
    }

    button {
      display: flex;
      align-items: center;

      span {
        cursor: pointer;

        @media all and (max-width: 767px) {
          display: none;
        }
      }

      img {
        margin-left: 10px;
      }
    }
  }

  .colored_btn,
  .color_btn {
    font-size: 16px;
    margin-top: 32px;
    flex: none;

    & + .error_notificatin {
      margin-top: 32px;
    }

    &.join_btn {
      margin-top: 0;
      margin-bottom: 0;

      & + .join_btn {
        margin-top: 16px;
      }
    }
  }
}

.modal {
  position: absolute;
  background-color: #fff;
  opacity: 0;
  pointer-events: none;
  display: none;
  transition: opacity 360ms;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 422px;
  border-radius: 16px;
  padding: 27px 32px 32px;

  @media all and (max-width: 769px) {
    padding: 16px;
  }

  @media all and (max-width: 767px) {
    width: calc(100% - 32px);
  }

  &.active {
    display: flex;
    opacity: 1;
    pointer-events: all;
    transition: opacity 360ms;
  }

  .inner {
    flex: 1 1 auto;
    margin-top: 0;
    margin-bottom: 0;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 0px;
    }
  }

  .transparent_btn {
    margin-top: 16px;
  }

  p + .color_btn {
    margin-top: 0;
  }
}

.big_modal {
  top: 32px;
  right: 32px;
  bottom: 32px;

  @media all and (max-width: 769px) {
    top: 16px;
    right: 16px;
    bottom: 16px;
  }

  @media all and (max-width: 767px) {
    top: 16px;
    right: auto;
    left: 16px;
    bottom: 16px;
  }

  .settings_apply {
    color: #fff;
    position: absolute;
    bottom: 32px;
    left: 32px;
    width: calc(100% - 64px);

    @media all and (max-width: 769px) {
      left: 16px;
      bottom: 16px;
      width: calc(100% - 32px);
    }
  }

  .subtitle {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    text-align: left;
    margin-bottom: 32px;
    margin-top: 32px;

    &:first-child {
      margin-top: 0;
    }
  }

  .settings_line {
    p {
      margin-bottom: 32px;
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      text-align: left;
    }

    .line {
      display: flex;
      align-items: center;
      padding-bottom: 15px;
      border-bottom: 1px solid #d6d6d6;
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      cursor: pointer;

      .select {
        display: flex;
        cursor: pointer;
        flex: 1 1 auto;
        padding-right: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      &.active {
        .arrow {
          opacity: 0.32;
          transition: transform 180ms, opacity 180ms;
          transform: rotate(180deg);
        }
      }
    }

    .icon {
      height: 22px;
      margin-right: 16px;
    }

    .arrow {
      height: 25px;
      opacity: 1;
      transition: transform 180ms, opacity 180ms;
      transform: rotate(0);
    }

    & + .settings_line {
      margin-top: 32px;
    }

    .drop {
      top: 100%;
      width: 100%;
      right: 0;

      button {
        color: #5c5c5c;
        display: flex;

        &.active {
          color: #000;
        }
      }
    }
  }

  .share_preview {
    margin-top: 24px;
  }
}

.centered_modal {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media all and (max-width: 767px) {
    left: 16px;
    right: 16px;
    transform: translate(0, -50%);
  }

  p {
    color: #5c5c5c;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    margin-bottom: 36px;

    @media all and (max-width: 767px) {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .or {
    color: #000;
    font-family: "Playfair Display", serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    margin-top: 32px;
    margin-bottom: 0;
    text-align: center;
  }

  .upgrade_big {
    margin-bottom: 16px;
    color: #000;
    font-family: "Playfair Display", serif;
    font-size: 36px;
    line-height: 48px;

    @media all and (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
    }
  }
}

.video_modal {
  top: 50%;
  left: 50%;
  width: auto;
  padding: 0;
  overflow: hidden;
  transform: translate(-50%, -50%);

  @media all and (max-width: 1025px) {
    left: 16px;
    right: 16px;
    transform: translate(0, -50%);
  }
}

.transparent_btn {
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
}
</style>
